import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
export const usePayoutsSummary = function usePayoutsSummary() {
    let { refreshOnHookMount = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { data, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: [
            QueryKeys.PayoutsSummary
        ],
        queryFn: ()=>api.payout.getSummary(),
        refreshOnHookMount
    });
    return {
        payoutsSummary: data,
        isLoading,
        isFetching,
        refresh,
        error
    };
};
